module.exports = __webpack_public_path__ + "img/like.d70ac528.svg";